import { Box, Card, Text } from '@mantine/core'
import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { useAuth } from '@percent/workplace-giving/common/hooks'
import { getPartnerFromAuthState } from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'
import { ButtonText } from '@percent/lemonade'
import { useLogout } from '@percent/workplace-giving/common/hooks/useLogout/useLogout'
import classes from './Layout.module.scss'

export type OnboardingLayoutProps = Readonly<{
  cardTitle: string
  cardDescription?: string
  className?: string
  cardClassName?: string
  cardHeader?: React.ReactNode
  footer?: React.ReactNode
}>

export function OnboardingLayout({
  cardTitle,
  className,
  cardDescription,
  cardClassName,
  cardHeader,
  footer,
  children
}: PropsWithChildren<OnboardingLayoutProps>) {
  const { t } = useTranslation()
  const authState = useAuth()
  const partner = getPartnerFromAuthState(authState.state)!
  const { logout } = useLogout()
  const partnerLogo = partner.configLogo || partner.logo

  return (
    <main className={classNames(classes.Wrapper, className)}>
      <Box className={classes.Header}>
        {partnerLogo ? <img className={classes.Logo} src={partnerLogo} alt={`${partner.name} logo`} /> : null}
        <ButtonText onClick={logout}>{t('workplace_giving.navigation.signOut')}</ButtonText>
      </Box>
      <Box className={classes.Content}>
        <Card className={classNames(classes.Card, cardClassName)}>
          <Box className={classes.InnerContent}>
            {cardHeader}
            <Box className={classes.CardHeader}>
              <Text component="h2" className={classes.CardTitle}>
                {cardTitle}
              </Text>
              {cardDescription ? <Text className={classes.CardDescription}>{cardDescription}</Text> : null}
            </Box>
            {children ? <Box className={classes.CardContent}>{children}</Box> : null}
            {footer ? <Box className={classes.CardFooter}>{footer}</Box> : null}
          </Box>
        </Card>
      </Box>
    </main>
  )
}
